import { useEffect } from "react";

const BRAND = "Car Market";

function setMeta(attr, value, content) {
  let el = document.head.querySelector(`meta[${attr}="${value}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, value);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/**
 * Lightweight client-side SEO meta updater.
 * Renders nothing — just mutates document.title and meta tags on mount.
 */
export default function Seo({ title, description, image, type = "website" }) {
  useEffect(() => {
    const fullTitle = title ? `${title} · ${BRAND}` : `${BRAND} — Cambodia's Car Marketplace`;
    document.title = fullTitle;

    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    setMeta("property", "og:title", fullTitle);
    setMeta("name", "twitter:title", fullTitle);
    setMeta("property", "og:type", type);
    setMeta("property", "og:site_name", BRAND);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("property", "og:url", window.location.href);

    if (image) {
      setMeta("property", "og:image", image);
      setMeta("name", "twitter:image", image);
    }
  }, [title, description, image, type]);

  return null;
}
